export const width = 564;
export const height = 420;
export default __webpack_public_path__ + "static/realtor-rafiki.18ebfe95.svg";